import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formattedNumber', standalone: true })
export class CustomDecimalPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}

  transform(value: number | string | null | undefined, digitsInfo?: string): string | null {
    return this.decimalPipe.transform(value, digitsInfo, 'ru')?.replace(',', '.') || null;
  }
}
